import { Injectable, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Subscription } from "rxjs";
import * as _ from "lodash";

import { AuthenticationService } from "../_services";
import { IUser } from "../_models";

@Injectable({ providedIn: "root" })
export class AuthGuard  implements OnInit, OnDestroy {
    currentUserSubscription: Subscription;
    currentUser: IUser;

    constructor(private router: Router, private authenticationService: AuthenticationService) {

    }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.currentUserSubscription.unsubscribe();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let canActivate = false;

        this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
            this.currentUser = user;

            if (this.currentUser) {
                //if the user is logged in but is missing properties required by the route, eg. housing requires that the student admissions app has been accepted and that they have an image
                //then redirect to the home page, similar to not having permission to access the route.
                const data = route.data as any;

                if (data.requiredProperties && data.requiredProperties.length > 0) {
                    _.forEach(data.requiredProperties, (f: any) => {
                        if ((f.indexOf("!") === -1 && !this.currentUser[f.replace("!","")]) || (f.indexOf("!") !== -1 && this.currentUser[f.replace("!","")])) {
                           this.router.navigate(["/"], { skipLocationChange: true });
                        }
                    });
                }

                // authorized so return true
                canActivate = true;
            }

        });

        if (!canActivate)
            // not logged in so redirect to login page with the return url
            this.router.navigate(["/login"], { queryParams: { returnUrl: state.url } });

        return canActivate;
    }
}